import apontamentoObservacaoReport from "entity/Indicador/reports/ApontamentoObservacaoReport";
import TableReportHelper from "report/helper";
import tmtHeaderReport from "./TMTHeaderReport";
import apontamentoImagesReport from "entity/Indicador/reports/ApontamentoImagesReport";

export default async function tmtReport(indicador, visita) {
    const h = new TableReportHelper(visita.data);
    const IndicadorClass = indicador.constructor;

    const apontamentos = visita.getApontamentosByIndicador(indicador);

    const content = [];

    for (const apontamento of apontamentos) {
        const params = visita.cliente.getParams(IndicadorClass, "Mecanizado", indicador.type)

        content.push([
            tmtHeaderReport(visita, indicador, apontamento, params),

            apontamentoImagesReport(visita, indicador, apontamento),
            apontamentoObservacaoReport(visita, indicador, apontamento),

            h.space(),
        ]);
    }

    return content;
}
